var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRallyIcon = function SvgRallyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.75 9.35a4.125 4.125 0 0 0 1.2-3c0-.712-.15-1.35-.412-1.95a3.563 3.563 0 0 0-1.126-1.35A4.125 4.125 0 0 0 8.675 2H4.25c-.75 0-1.163.15-1.313.45-.075.112-.15.262-.15.412v9.563a2.25 2.25 0 0 0 .075.862c.113.375.563.6 1.313.6s2.025-.15 2.212-.45l.15-.412v-2.438h2.588l1.275 2.925a.9.9 0 0 0 .825.488c.3-.017.593-.093.863-.225.675-.3 1.012-.638 1.012-1.05a2.13 2.13 0 0 0-.262-.825l-1.125-2.55h.037ZM8.637 3.125c1.65 0 3 1.388 3 3.112 0 1.726-1.35 3.075-3 3.075s-3-1.387-3-3.074c0-1.726 1.35-3.113 3-3.113Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.75 2h10.5v12H2.75z"
  })))));
};
export default SvgRallyIcon;